module.exports = __webpack_public_path__ + "img/wallet.6c1faa8e.svg";